/*
 * @Date: 2021-05-17 14:37:54
 * @Author: zhujuan
 * @LastEditors: Smart Chow
 * @LastEditTime: 2022-04-05 16:37:51
 */

import { DEFAULT_CHECK_LEVEL_DICT_CODE } from '@/apps/modules/common/constants/dictKeys'
import { GetXTMJList } from '@/apps/modules/common/_api/index'
export default {
  data() {
    return {
      defaultCheckLevel: ''
    }
  },

  methods: {
    getDefaultCheckLevel() {
      return new Promise((resolve, reject) => {
        //1143 默认质控级别
        let Mjdm = DEFAULT_CHECK_LEVEL_DICT_CODE
        GetXTMJList({ Mjdm })
          .then((res) => {
            if (res.success) {
              let data = res.data
              let dictItem = data.filter(
                (item) => item.MJDM === DEFAULT_CHECK_LEVEL_DICT_CODE
              )[0]
              if (dictItem.JLZT !== '1') {
                resolve()
                return
              }
              let memo = dictItem.BZ
              if (!!memo && memo.split(':').length > 1) {
                this.defaultCheckLevel = memo.split(':')[1]
              }
            }
            resolve(this.defaultCheckLevel)
          })
          .catch((error) => reject(error))
      })
    }
  }
}
